"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        value: 0,
        picList: { type: Object, default: {} }
    },
    data: function data() {
        return {
            shownPic: ''
        };
    },

    watch: {
        value: function value(newValue, oldValue) {
            if (typeof this.picList[newValue] !== "undefined") {
                this.shownPic = this.picList[newValue];
            }
        }
    },
    ready: function ready() {
        if (typeof this.picList[this.value] !== "undefined") {
            this.shownPic = this.picList[this.value];
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "<img class=\"imgset-{{ value }}\" :src=shownPic alt=\"\">"
